import { useEffect, useState } from 'react';
import {
  getAmplifyVisitorRegion,
  getCachedAmplifyVisitorRegion,
  type VisitorRegionSource,
} from '../utils/amplifyGeo';

type UseIsHongKongIpState = {
  isHK: boolean;
  isUS: boolean;
  isRestrictedRegion: boolean;
  ready: boolean;
  countryCode: string | null;
  source: VisitorRegionSource | 'loading';
  /**
   * False only when Hong Kong or the United States has been positively identified.
   * Loading, unresolved and fallback states remain visible (fail-open).
   */
  canShowRestrictedContent: boolean;
};

function buildInitialState(): UseIsHongKongIpState {
  const cached = getCachedAmplifyVisitorRegion();

  if (cached) {
    return {
      isHK: cached.isHK,
      isUS: cached.isUS,
      isRestrictedRegion: cached.isRestrictedRegion,
      ready: true,
      countryCode: cached.countryCode,
      source: cached.source,
      canShowRestrictedContent: !cached.isRestrictedRegion,
    };
  }

  return {
    isHK: false,
    isUS: false,
    isRestrictedRegion: false,
    ready: false,
    countryCode: null,
    source: 'loading',
    canShowRestrictedContent: true,
  };
}

export function useIsHongKongIp(): UseIsHongKongIpState {
  const [state, setState] = useState<UseIsHongKongIpState>(buildInitialState);

  useEffect(() => {
    let active = true;

    void getAmplifyVisitorRegion().then((region) => {
      if (!active) return;

      setState({
        isHK: region.isHK,
        isUS: region.isUS,
        isRestrictedRegion: region.isRestrictedRegion,
        ready: true,
        countryCode: region.countryCode,
        source: region.source,
        canShowRestrictedContent: !region.isRestrictedRegion,
      });
    });

    return () => {
      active = false;
    };
  }, []);

  return state;
}
